import LoadingPresenter from '@components/Loading';
import { useSnackbar } from '@components/Provider';
import {
  CapaErrorCode,
  CapaServiceType,
  useAuthenticateLazyQuery
} from '@generated/graphql';
import useClient from '@hooks/useClient';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { WithdrwalStage } from '../useWithdrawalStage';
import ConfirmPasswordPresenter from './ConfirmPasswordPresenter';

interface Props {
  matches: boolean;
  setStage: (stage: WithdrwalStage) => void;
}

const ConfirmPasswordContainer = ({ setStage }: Props) => {
  const { clientState, onUpdateToken } = useClient();

  const { enqueueSnackbar } = useSnackbar();

  const [authenticate, { data, loading }] = useAuthenticateLazyQuery();

  const { reset, setValue, handleSubmit, control } = useForm<{
    email: string;
    password: string;
  }>({
    defaultValues: {
      email: clientState.email
    }
  });

  useEffect(() => {
    reset({ email: clientState.email });
  }, [reset, clientState.email]);

  const onSubmit = handleSubmit(
    (data) => {
      if (!data.password) return;

      authenticate({
        variables: {
          ...data,
          service: CapaServiceType.Quotation
        }
      });
    },
    (err) => {
      if (err.password?.type === 'required') {
        enqueueSnackbar('비밀번호를 입력해주세요.', { variant: 'error' });
      }
    }
  );

  useEffect(() => {
    if (data?.authenticate.result === CapaErrorCode.Success) {
      return setStage('confirm-membership');
    } else if (
      data?.authenticate.result === CapaErrorCode.ParmeterValidationError ||
      data?.authenticate.result === CapaErrorCode.PasswordIncorrect
    ) {
      setValue('password', '');

      enqueueSnackbar(
        '비밀번호가 일치하지 않습니다. 다시 확인해주세요. 계정 관련 문의는 고객센터(support@capa.ai)로 연락 주세요.',
        { variant: 'error' }
      );
    } else {
      setValue('password', '');
    }
  }, [data, enqueueSnackbar, setValue, setStage]);

  useEffect(() => {
    if (
      data &&
      data.authenticate.data?.accessToken &&
      data.authenticate.data?.refreshToken
    ) {
      onUpdateToken({
        accessToken: data.authenticate.data?.accessToken,
        refreshToken: data.authenticate.data?.refreshToken
      });
    }
  }, [data, onUpdateToken]);

  return (
    <>
      {loading && <LoadingPresenter open />}
      <ConfirmPasswordPresenter control={control} onSubmit={onSubmit} />
    </>
  );
};

export default ConfirmPasswordContainer;
